import { lazy } from 'react';
import {
    RouteAccess,
    type RouteConfigExtended,
    errorAccountTemporarilyLockedPath,
    errorLanguagePath,
    errorPlanNotAvailablePath,
    errorTransactionsLimitExceededPath,
    extraCreditsNotAvailablePath,
    studentServerErrorPath,
} from '@lingoda/router';
import { NotFoundPage } from '@lingoda/fallbacks';

const ErrorPlanNotAvailable = lazy(() => import('./pages/PlanNotAvailable'));
const ErrorLanguagePage = lazy(() => import('./pages/ErrorLanguage'));
const ServerErrorPage = lazy(() => import('./pages/ServerErrorPage'));
const ExtraCreditsNotAvailableErrorPage = lazy(() => import('./pages/ExtraCreditsNotAvailable'));
const ErrorTransactionsLimitExceeded = lazy(() => import('./pages/TransactionsLimitExceeded'));
const ErrorAccountTemporarilyLocked = lazy(() => import('./pages/AccountTemporarilyLocked'));

export const routes: RouteConfigExtended[] = [
    {
        exact: true,
        component: ErrorLanguagePage,
        path: errorLanguagePath.raw,
        label: 'ErrorLanguage',
        config: {
            access: RouteAccess.Public,
            tab: undefined,
        },
    },
    {
        component: ErrorPlanNotAvailable,
        label: 'PlanNotAvailable',
        path: errorPlanNotAvailablePath.raw,
        config: {
            access: RouteAccess.Public,
            hideFooter: true,
            hideNotifications: true,
            tab: undefined,
        },
    },
    {
        component: ExtraCreditsNotAvailableErrorPage,
        label: 'ExtraCreditsNotAvailable',
        path: extraCreditsNotAvailablePath.raw,
        config: {
            access: RouteAccess.Public,
            hideFooter: true,
            hideNotifications: true,
            tab: undefined,
        },
    },
    {
        exact: true,
        component: ServerErrorPage,
        path: studentServerErrorPath.raw,
        label: 'ServerError',
        config: {
            access: RouteAccess.Public,
            hideNotifications: true,
            tab: undefined,
        },
    },
    {
        exact: true,
        component: ErrorTransactionsLimitExceeded,
        path: errorTransactionsLimitExceededPath.raw,
        label: 'TransactionsLimitExceeded',
        config: {
            access: RouteAccess.Public,
            hideNotifications: true,
            tab: undefined,
        },
    },
    {
        exact: true,
        component: ErrorAccountTemporarilyLocked,
        path: errorAccountTemporarilyLockedPath.raw,
        label: 'AccountTemporarilyLocked',
        config: {
            access: RouteAccess.Public,
            hideNotifications: true,
            hideHeader: true,
            tab: undefined,
        },
    },
    {
        component: NotFoundPage,
        label: 'PageNotFound',
        config: {
            access: RouteAccess.Public,
            tab: undefined,
        },
    },
];
